import {Component, NgModule} from '@angular/core';

@Component({
  selector: 'not-found',
  template: ` <h1>Page not found</h1>`,
})
export class NotFoundComponent {
}

@NgModule({
  declarations: [
    NotFoundComponent
  ],

  exports: [NotFoundComponent]
})

export class NotFoundModule {
}
